import React, { useEffect, useState } from 'react';
import axios from 'common/AxiosAuth';
import { Text } from 'components';
import { ScheduleItem } from 'pages/Dashboard/types';
import { scheduleStatus } from 'utils/statusDefinitions';

export const LatestScheduleSection = () => {
  const [data, setData] = useState<ScheduleItem[]>([]);
  
  useEffect(() => {
    axios
      .get('/api/dashboard/schedule?limit=5')
      .then((res) => {
        console.log('Dashboard schedule data:', res.data.data);
        setData(res.data.data);
      })
      .catch((err) => console.error('스케줄 조회 실패', err));
  }, []);



  const getStatusBadge = (status: string) => {
    const statusConfig = scheduleStatus[status?.toUpperCase()];
    
    if (statusConfig) {
      return (
        <div className={`inline-flex items-center border rounded-full px-3 py-1 text-xs font-medium ${statusConfig.className}`}>
          {statusConfig.title}
        </div>
      );
    }
    
    return (
      <div className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-800">
        {status}
      </div>
    );
  };

  return (
    <div className="min-w-0 flex-1 overflow-hidden rounded-xl border border-border-primary bg-bg-layer3">
      <div className="border-b border-border-primary p-4">
        <Text size="body2" weight="semibold" color="primary">
          Latest Scheduled Passes
        </Text>
      </div>
      
      {data.length === 0 ? (
        <div className="flex min-h-[160px] items-center justify-center text-sm text-secondary text-center">
          There are no recently scheduled passes.
        </div>
      ) : (
                <div className="p-2 space-y-2 overflow-x-auto">
          {data.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg border border-gray-200 px-2 py-2 min-w-[840px]"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-5 flex-1">
                  <div className="w-20 flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">Spacecraft</p>
                    <p className="text-sm text-gray-900 truncate">
                      {item.spacecraftName || 'Unknown'}
                    </p>
                  </div>
                  <div className="w-30 flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">Ground Station</p>
                    <p className="text-sm text-gray-900 truncate">
                      {item.groundStationName || 'Unknown'}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">AOS</p>
                    <p className="text-sm text-gray-900">
                      {item.startTime}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">LOS</p>
                    <p className="text-sm text-gray-900">
                      {item.endTime}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">Available (sec)</p>
                    <p className="text-sm text-gray-900">
                      {item.availableTime || '0'}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <p className="text-xs text-gray-500 font-medium">Max Elevation (°)</p>
                    <p className="text-sm text-gray-900">
                      {item.maxElevation || '0'}°
                    </p>
                  </div>
                </div>
                <div className="flex-shrink-0 ml-2">
                  {getStatusBadge(item.status)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
